var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"manageresumes"},[_c('div',{staticClass:"main-wrapper"},[_c('main-header'),_c('sidebar'),_c('div',{staticClass:"page-wrapper"},[_c('div',{staticClass:"content container-fluid"},[_c('headerresume'),_c('resumecontent')],1),_c('modalresume')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }